import { LineItem } from 'shared/types/cart';
import { PRIMARY_SUBJECT_AREA } from 'constants/cart';
import { careerCardContent } from '../constant/careerCardContent';

type CategoriesKeys = keyof typeof careerCardContent;

export const getCategory = (products: LineItem[]): CategoriesKeys | null => {
  // function to determine what course has the highest content priority
  const category = products?.reduce<{ priority: number; name: string }>(
    (acc, product) => {
      const subject =
        product?.variant?.attributes?.[PRIMARY_SUBJECT_AREA]?.toLowerCase();
      const isValidCategory = !!subject && subject in careerCardContent;

      if (!isValidCategory) {
        return acc;
      }

      const currentCategory = careerCardContent[subject as CategoriesKeys];

      // check if the current category has a higher priority
      if (acc.name === '' || currentCategory.priority < acc.priority) {
        return {
          priority: currentCategory.priority,
          name: subject,
        };
      }

      return acc;
    },
    {
      priority: Number.POSITIVE_INFINITY,
      name: '',
    },
  );

  return (category?.name as CategoriesKeys) || null;
};
